// Shared follow-up outcome vocabulary (used by sheet, manager and dashboard).
export const OUTCOME_OPTS = [
  { value: 'called_no_answer', label: 'Called — no answer' },
  { value: 'interested', label: 'Interested' },
  { value: 'not_interested', label: 'Not interested' },
  { value: 'payment_promised', label: 'Payment promised' },
  { value: 'converted', label: 'Converted' },
  { value: 'other', label: 'Other' },
];

export const OUTCOME_LABEL = {
  pending: 'Pending',
  called_no_answer: 'Called — no answer',
  interested: 'Interested',
  not_interested: 'Not interested',
  payment_promised: 'Payment promised',
  converted: 'Converted',
  other: 'Other',
};

export const OUTCOME_TONE = {
  pending: 'bg-slate-100 text-slate-600 border-slate-200',
  called_no_answer: 'bg-slate-100 text-slate-600 border-slate-200',
  interested: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  not_interested: 'bg-rose-50 text-rose-700 border-rose-200',
  payment_promised: 'bg-amber-50 text-amber-700 border-amber-200',
  converted: 'bg-emerald-100 text-emerald-800 border-emerald-300',
  other: 'bg-slate-100 text-slate-600 border-slate-200',
};

// A small subset surfaced as inline quick-action buttons.
export const QUICK_OUTCOMES = ['called_no_answer', 'interested', 'payment_promised', 'converted'];

export const fmtFollowDate = (d, t) => {
  if (!d) return '';
  try {
    const dt = new Date(`${d}T${t || '00:00'}`);
    const datePart = dt.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
    return t ? `${datePart} · ${t}` : datePart;
  } catch { return d; }
};
